import { DataFieldType } from "src/types/data-field.types";
import { NodeContext } from "src/types/node-context.types";
import { createNodeDef } from "../nodes.helpers";

export const arrayNodeDef = createNodeDef({
  type: "array",
  displayName: "Array",
  description: "A list with all child nodes",
  acceptsChildren: true,
  fields: [{ type: DataFieldType.NUMBER, key: "length", label: "Repeat" }],
  initialData: () => ({ length: 1 }),
  generate: async ({ node, children, context }) => {
    const result: unknown[] = [];

    const setIndex = (ctx: NodeContext) =>
      ctx.append({
        name: `${node.name}Index`,
        nodeType: node.type,
        value: result.length,
      });

    for (let i = 0; i < node.data.length; i++) {
      const childContext = context.copy();
      childContext.append({
        name: `${node.name}Loop`,
        nodeType: node.type,
        value: i,
      });

      const generator = children.withContext(childContext);
      for await (const { value } of generator.loop(setIndex)) {
        result.push(value);
      }
    }

    return result;
  },
});
